export default () => ({
    isPlaying: true,
    isMuted: true,

    getVideoElement() {
        return this.$root.querySelector('video')
    },

    toggle() {
        const video = this.getVideoElement()

        if (!video.paused) {
            video.pause()
        } else {
            video.play()
        }
    },

    toggleAudio() {
        const video = this.getVideoElement()

        video.muted = !video.muted
    },

    init() {
        const video = this.getVideoElement()
        const mediaQuery = window.matchMedia('(min-width: 768px)')
        let prevIsPlaying = this.isPlaying
        let prevIsMuted = this.isMuted

        mediaQuery.addEventListener('change', () => {
            const isHidden = getComputedStyle(this.$root).display === 'none'

            if (isHidden) {
                prevIsPlaying = this.isPlaying
                prevIsMuted = this.isMuted

                video.pause()
                video.muted = true
            } else {
                if (prevIsPlaying) {
                    video.play()
                }

                video.muted = prevIsMuted
            }
        })
        video.addEventListener('play', () => (this.isPlaying = true))
        video.addEventListener('pause', () => (this.isPlaying = false))
        video.addEventListener(
            'volumechange',
            () => (this.isMuted = video.muted)
        )
        video.play()
    },
})
